import React from 'react';
import styled from 'styled-components';
import { deprecated } from '@ally/metronome-icons';
import { Button, useModalContext } from '@ally/metronome-ui';
const LightTrigger = styled(Button) `
  color: white;

  & path {
    fill: white;
  }
`;
const DarkTrigger = Button;
// base Trigger component, agnostic of Modal usage
export const Trigger = ({ variant, asIcon, onClick, }) => {
    const Component = variant === 'dark' ? DarkTrigger : LightTrigger;
    return (React.createElement(Component, { variant: "link", icon: Object.assign({}, (asIcon ? { map: deprecated.muiHelpOutline } : {})), onClick: onClick, text: asIcon ? '' : 'Help', "data-testid": `${variant}-trigger`, "data-anchor-id": "help-modal", "aria-label": "Help", allytmln: "help" }));
};
export const ModalTrigger = ({ variant, asIcon }) => {
    const { setOpen } = useModalContext();
    return (React.createElement(Trigger, { variant: variant, asIcon: asIcon, onClick: () => setOpen(true) }));
};
//# sourceMappingURL=Trigger.js.map